import data from "./experience.json"

export default {
    data: data,
    lang: "en",
    verbose: false
};
